import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';

import Alert from 'components/icons/alert';
import WithTooltip from 'components/tooltip/withTooltip';

import s from 'components/badge/badge.sss';

export default class Badge extends Component {
	s = s;

	renderAlert(props = this.props) {
		return !!props.alert && <Alert />;
	}

	renderBadgeContent(props = this.props) {
		const hasChildren = Array.isArray(props.children) ? props.children.length : !!props.children;
		return hasChildren ? props.children : props.type;
	}

	renderBadge(props = this.props) {
		return (
			<div class={joinClasses(this.s.badge, props.dark && this.s.dark, this.s[`badge-${props.type}`], props.class)}>
				{this.renderBadgeContent(props)}
			</div>
		);
	}

	render(props) {
		if (!props.alert || props.hideTooltip) return this.renderBadge(props);
		
		return (
			<WithTooltip dark={props.dark} direction="bottom" align="start" tooltip={props.alertMessage || 'Live, with unpublished changes'}>
				{this.renderBadge(props)}
			</WithTooltip>
		);
	}
}